import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import PreviewIcon from '@mui/icons-material/Preview';

import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleMatOutward } from '../../../Store/PHPSlice/MatOutward';

const TableBody = ({
    id,
    serialNumber,
    barcode,
    materialNm,
    matId,
    size,
    mqty,
    mtype,
    perpktqty,
    ptype,
    locationId,
    locNm,
    firmId,
    firmNm,
    actpqty,
    balpqty,
    actmtr,
    balmtr,
    actInch,
    balInch,
    actTotqty,
    balTotqty,
    spqty,
    smtr,
    sInch,
    sTotqty,
    selected,
    handleClick,
}) => {

    const dispatch = useDispatch();
    const handleViewClick = () => {
        // Replace 'URL' with the actual URL you want to open
        //alert("matId=>"+matId);
        window.open(`/MaterialStockView/${barcode}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        const isConfirmed = window.confirm("Are you sure you want to delete this Material Outward?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleMatOutward(matId))
                .then(() => {
                    // Reload the page to show updated results
                    toast("Material Outward Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Material Outward:", error);
                    toast.error("Failed to delete Material Outward");
                });
        }
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>
                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{firmNm}</TableCell> */}

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{locNm}</TableCell>
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'><b>{barcode}</b></TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{materialNm}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {size}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{mqty}{" "}{mtype}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {perpktqty} {" "} {ptype}
                </TableCell>


                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'blue', fontWeight: 600 }}>
                        {actpqty}
                    </Typography>
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'green', fontWeight: 600 }}>
                        {spqty}
                    </Typography>
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'red', fontWeight: 600 }}>
                        {balpqty}
                    </Typography>
                </TableCell>



                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'blue', fontWeight: 600 }}>
                        {actmtr}
                    </Typography>
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'green', fontWeight: 600 }}>
                        {smtr}
                    </Typography>
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'red', fontWeight: 600 }}>
                        {balmtr}
                    </Typography>
                </TableCell>


                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'blue', fontWeight: 600 }}>
                        {actInch}
                    </Typography>
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'green', fontWeight: 600 }}>
                        {sInch}
                    </Typography>
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'red', fontWeight: 600 }}>
                        {balInch}
                    </Typography>
                </TableCell>


                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'blue', fontWeight: 600 }}>
                        {actTotqty}
                    </Typography>
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'green', fontWeight: 600 }}>
                        {sTotqty}
                    </Typography>
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align="center">
                    <Typography sx={{ color: 'red', fontWeight: 600 }}>
                        {balTotqty}
                    </Typography>
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <PreviewIcon className='cursor-pointer' onClick={handleViewClick} />
                    {/* <PreviewIcon className='cursor-pointer' /> */}
                </TableCell>

            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody;
